import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/page-case/page-case-view.tsx");
